
import React from 'react';
import { Event } from '@/lib/types';
import { Button } from "@/components/ui/button";
import { Pencil, Trash2, Eye } from 'lucide-react';
import { getEventDateRangeString } from '@/lib/eventHelpers';
import { eventTypeLabels } from '@/lib/eventLabels';
import StatusBadge from './StatusBadge';
import { EventStatus } from '@/services/eventService';

interface EventsTableRowProps {
  event: Event;
  onView: (event: Event) => void;
  onEdit: (event: Event) => void;
  onDelete: (event: Event) => void;
}

const EventsTableRow = ({ event, onView, onEdit, onDelete }: EventsTableRowProps) => {
  // Using the Hungarian date format utility
  const formattedDate = getEventDateRangeString(event.dateStart, event.dateEnd);
  
  return (
    <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
      <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
        {event.name}
      </th>
      <td className="px-6 py-4">
        {event.description}
      </td>
      <td className="px-6 py-4">
        {formattedDate}
      </td>
      <td className="px-6 py-4">
        {event.venue.city}, {event.venue.name}
      </td>
      <td className="px-6 py-4">
        {eventTypeLabels[event.type as keyof typeof eventTypeLabels] || event.type}
      </td>
      <td className="px-6 py-4">
        <StatusBadge status={event.status as EventStatus || EventStatus.DRAFT} />
      </td>
      <td className="px-6 py-4">
        <div className="flex space-x-2">
          <Button variant="secondary" size="icon" onClick={() => onView(event)}>
            <Eye className="h-4 w-4" />
          </Button>
          <Button variant="outline" size="icon" onClick={() => onEdit(event)}>
            <Pencil className="h-4 w-4" />
          </Button>
          <Button variant="destructive" size="icon" onClick={() => onDelete(event)}>
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      </td>
    </tr>
  );
};

export default EventsTableRow;
